import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useProjectScheduleDetail = (id: number, group_id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [scheduleInfo, setScheduleInfo] = useState<ProjectScheduleInfoDto>();
  const [scheduleOnoInfo, setScheduleOnoInfo] = useState<ProjectScheduleOnoInfoDto>();
  
  const [lastInsertSrl, setLastInsertSrl] = useState<any>(0);

  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading, refetch } = useQuery(
    [endpoints.project.schedule.info, id],
    () =>
      fetcher.project.postProjectScheduleInfo({id: id, group_id: group_id}),
    {
      enabled: (id > 0 || group_id > 0),
      onSuccess: (res: ProjectScheduleInfoResDto) => {
        switch (res.code) {
          case 200:
            setScheduleInfo(res.result?.info);
            setScheduleOnoInfo(res.result?.onoInfo);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: projectScheduleInsert, isLoading: isLoadingInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.project.schedule.add],
    fetcher.project.postProjectScheduleInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            if (!!res.result) setLastInsertSrl(res.result.id)
            message.info(MSG.SUCCESS_INSERT, 1);
            break;
          case 400:
            alert(MSG.ERROR_DUP_EXCEPTPRICE);
            break;                          
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;              
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: projectScheduleUpdate, isLoading: isLoadingUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.project.schedule.update],
    fetcher.project.postProjectScheduleUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          case 400:
            alert(MSG.ERROR_DUP_EXCEPTPRICE);
            break;              
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;               
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: projectScheduleDelete, isLoading: isLoadingDelete, isSuccess: deleteSuccess } = useMutation(
    [endpoints.project.schedule.delete],
    fetcher.project.postProjectScheduleDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;               
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )     
  
  return { 
    isLoading, 
    isLoadingInsert,
    isLoadingUpdate,
    isLoadingDelete,
    refetch, 
    lastInsertSrl, 
    scheduleInfo, 
    scheduleOnoInfo, 
    insertSuccess, 
    updateSuccess, 
    deleteSuccess, 
    projectScheduleInsert, 
    projectScheduleUpdate, 
    projectScheduleDelete,     
  };
};

export default useProjectScheduleDetail;
